var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChatNow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icChatNow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.01942199,23.1 C5.9624537,23.1 5.90480951,23.0860059 5.85286215,23.0581136 C5.73892556,22.9973448 5.66795658,22.8787784 5.66795658,22.7510105 L5.66795658,17.7792765 C2.59070311,16.1908521 0.9,13.4097674 0.9,9.9252403 C0.9,4.54029738 5.88656034,0.48 12.5,0.48 C19.1134397,0.48 24.1,4.54029738 24.1,9.9252403 C24.1,15.3094164 19.1134397,19.3697138 12.5,19.3697138 C12.282748,19.3697138 12.0697445,19.3579243 11.8560652,19.3467098 L11.8419679,19.3460389 L6.21272797,23.0420108 C6.15440788,23.0804466 6.08691494,23.1 6.01942199,23.1 Z M7.135,11.79 C7.93581289,11.79 8.585,11.1408129 8.585,10.34 C8.585,9.53918711 7.93581289,8.89 7.135,8.89 C6.33418711,8.89 5.685,9.53918711 5.685,10.34 C5.685,11.1408129 6.33418711,11.79 7.135,11.79 Z M12.5,11.79 C13.3008129,11.79 13.95,11.1408129 13.95,10.34 C13.95,9.53918711 13.3008129,8.89 12.5,8.89 C11.6991871,8.89 11.05,9.53918711 11.05,10.34 C11.05,11.1408129 11.6991871,11.79 12.5,11.79 Z M17.865,11.79 C18.6658129,11.79 19.315,11.1408129 19.315,10.34 C19.315,9.53918711 18.6658129,8.89 17.865,8.89 C17.0641871,8.89 16.415,9.53918711 16.415,10.34 C16.415,11.1408129 17.0641871,11.79 17.865,11.79 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icChatNow",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChatNow);
export default __webpack_public_path__ + "static/media/icChatNow.d14d31c05ffeeaea1d1eb1757ef9860b.svg";
export { ForwardRef as ReactComponent };